interface Props {
  item: string,
  handleChange: (newValue: string) => void,
  setOpen?: any
}
export function DropDownItem({ item, handleChange, setOpen }: Props) {
  return (
    <p
      key={item}
      className="py-2 text-sm px-4 hover:bg-pinkAccent cursor-pointer rounded-sm capitalize"
      onClick={() => {
        handleChange(item)
        setOpen(false)
      }}>
      {item}
    </p>
  );
}